





























































import {Component, Vue, Watch} from 'vue-property-decorator';
import {CustomerProfileStore, SessionStore} from '../../store';
import {MonitoringService, WebService} from '../../services';


type TFieldName = 'dataPrivate' | 'receiveOffers';

@Component
export default class TermsOfService extends Vue {
	dataPrivate = true;
	disableInput = false;
	receiveOffers = true;

	saving: Record<TFieldName, boolean> = {
		dataPrivate: false,
		receiveOffers: false,
	};

	get brandConfig() {
		return SessionStore.brandConfig;
	}

	get customerProfile() {
		return CustomerProfileStore.customerProfile;
	}

	@Watch('customerProfile', {immediate: true})
	onCustomerProfileChange() {
		if(this.customerProfile) {
			this.dataPrivate = this.customerProfile.dataPrivate;
			this.receiveOffers = this.customerProfile.receiveOffers;
		}
	}


	async acceptTOS() {
		this.$emit('before-accept-tos');
		this.disableInput = true;

		try {
			await CustomerProfileStore.acceptTOS();
			this.$emit('accept-tos');
		} catch(error) {
			console.error(error);
			this.$q.dialog({
				title: 'Error',
				message: 'There was a problem accepting the Terms of Service.'
			});
			MonitoringService.captureException(error);
		} finally {
			this.disableInput = false;
			this.$emit('after-accept-tos');
		}
	}

	async inputChanged(fieldName: TFieldName) {
		if(this.customerProfile) {
			try {
				Vue.set(this.saving, fieldName, true);
				await CustomerProfileStore.updateProfile({
					receiveOffers: this.receiveOffers,
					dataPrivate: this.dataPrivate,
				});
			} catch(error) {
				console.error(error);
				this.$q.dialog({
					title: 'Error',
					message: 'There was a problem saving your profile.'
				});
				MonitoringService.captureException(error);
			} finally {
				Vue.set(this.saving, fieldName, false);
			}
		}
	}

	logout() {
		this.$q.dialog({
			title: 'Confirm',
			message: 'Are you sure you want to logout?',
			cancel: true,
			persistent: true
		}).onOk(async () => {
			await WebService.logout();
			this.$emit('app-logout');
		});
	}
}
